<template>
  <div class="FirstProduct">
    <MainPageHeader/>
    <div class="content">
      <header>
        <router-link class="back-button" :to="{ name: 'mainPage' }">
          <font-awesome-icon icon="arrow-left"/>
          <p class="font-size-middle">Wyjdź</p>
        </router-link>
      </header>
      <div class="divider"/>

      <section class="section-1">
        <div class="firstPart">
          <div class="info">
            <h2 class="font-size-big">System Vocale</h2>
            <p class="font-size-middle">
              Pierwszy nowoczesny i wygodny w obsłudze <strong>System Vocale</strong>
              stworzony specjalnie na potrzeby zespołów muzycznych do zarządzania utworami
              muzycznymi w czasie koncertu. Aktualnie grany utwór wyświetli się na wszystkich
              tabletach jednocześnie, a dostęp do systemu otrzymasz poprzez tablet, smartphone
              oraz komputer.
            </p>
          </div>
          <!-- <div class="image"> -->
            <img class="image-placeholder" src="@/assets/images/product_1_1image.png"/>
          <!-- </div> -->
        </div>

        <h2 class="font-size-big">Miej stały podgląd kto jest podłączony</h2>
        <div class="info">
          <p class="font-size-middle">
            Na stronie głównej Administrator zespołu ma stały podgląd którzy użytkownicy są
            podłączeni do <strong>Systemu Vocale.</strong> Pozostałym użytkownikom w momencie
            oczekiwania na przesłanie tekstu zostanie wyświetlony wygaszacz ekranu.
          </p>
        </div>
        <div class="image">
          <img class="image-placeholder" src="@/assets/images/product_1_connected_people.png"/>
        </div>

        <h2 class="font-size-big">Stwórz swoją kolekcję</h2>
        <div class="info">
          <p class="font-size-middle">
            Utwórz swoją muzyczną bibliotekę i zabierz ze sobą dokądkolwiek się udajesz.
          </p>
          <p class="font-size-middle">
            Skorzystaj z biblioteki globalnej, w której znajdują się piosenki najbardziej
            powtarzalne, lub możesz dodać własne w formie tekstu lub zdjęć.
          </p>
        </div>
        <div class="image">
          <img class="image-placeholder" src="@/assets/images/product_1_playlists.png"/>
        </div>


        <h2 class="font-size-big">Dostosuj muzykę podczas koncertu</h2>
        <div class="info">
          <p class="font-size-middle">
            W pełni funkcjonalny <strong>System Vocale</strong> pozwala podczas grania setu/
            koncertu dodawać piosenki do kolejki, usuwać piosenki lub zmieniać kolejność a
            każdy członek zespołu<br> zostanie poinformowany o tym w trybie rzeczywistym.
          </p>
        </div>
        <div class="image">
          <img class="image-placeholder1" src="@/assets/images/product_1_7image.png"/>
        </div>


        <h2 class="font-size-big">Gdziekolwiek jesteś - Vocale Offline będzie z Tobą</h2>
        <div class="info">
          <p class="font-size-middle">
            Dzięki zastosowaniu inteligentnej infrastruktury, <strong>System Vocale</strong>
            działa offline (bez dostępu do internetu), aby wyświetlać szybko piosenki na wszystkich
            urządzeniach zespołu jednocześnie bez względu na to czy jest internet w miejscu koncertu.
          </p>
        </div>
        <div class="image">
          <img class="image-placeholder" src="@/assets/images/product_1_connectTablet.png"/>
        </div>


        <h2 class="font-size-big">Niezawodne przechowywanie danych</h2>
        <div class="info">
          <p class="font-size-middle">
            Nasz zespół zdaje sobie sprawę jak ważne jest dla Ciebie zadowolenie uczestników imprezy,
            dlatego <strong>System Vocale</strong> zabezpieczy Twój śpiewnik w chmurze do którego
            masz dostęp kiedy tylko zechcesz.
          </p>
        </div>
        <div class="image">
          <img class="image-placeholder" src="@/assets/images/product_1_logoVocale.png"/>
        </div>

        <h2 class="font-size-big">Zacznij w 3 prostych krokach</h2>
        <div class="image">
          <img class="image-placeholder" src="@/assets/images/product_1_3image.png"/>
        </div>

      </section>
      <div class="divider"/>

      <section class="section-2">
        <h1 class="text-header font-size-big" style="padding-bottom: 0; margin-bottom: 0;">
          Sprawdź też <strong>PAKIET Vocale Gold</strong>
        </h1>
        <h4 class="text-header" style="margin-top: 2px; padding-top: 6px">z wysokiej klasy tabletem i akcesoriami</h4>
        <p class="font-size-middle">
          Dzięki niemu zyskasz dostęp nie tylko do <strong>Systemu Vocale</strong> ale otrzymasz również wysokiej klasy
          tablet <strong>VOCALE Tab 10 PRO</strong>, dedykowany statyw <strong>VOCALE Tripod</strong>,
          eleganckie etui <strong>VOCALE Case</strong>, przewód 3m dostosowany
          do systemu oraz szkło hartowane, które pozwoli zabezpieczyć ekran urzadzenia.
        </p>
        <BigButton class="big-button" borderColor="primary" @click="route({
                    name: 'secondProduct'
                })">SPRAWDŹ
        </BigButton>
      </section>
      <!--      <section class="section-2">-->
      <!--      <header class="section-header">-->
      <!--<h3>Dane podstawowe</h3>-->
      <!--      </header>-->
      <!--        <table>-->
      <!--          <tbody>-->
      <!--          <tr>-->
      <!--            <th>-->
      <!--              Producent-->
      <!--            </th>-->
      <!--            <td>-->
      <!--              <ul>-->
      <!--                <li>-->
      <!--                  PAKIET Vocale Gold-->
      <!--                </li>-->
      <!--              </ul>-->
      <!--            </td>-->
      <!--          </tr>-->
      <!--          </tbody>-->
      <!--        </table>-->


      <!--      </section>-->
      <div class="divider"/>
      <InfoSectionFirstProduct/>
    </div>
    <TabFooter
        :name="productDetails.name"
        :price="productDetails.price"
        :quantity="productDetails.quantity"
        :period="productDetails.period"
        @buttonClicked="route({
                name: 'summaryPage',
                params: { id: '1' },
            })"
    />
    <PageNotFound v-if="loadError" :message="loadError"/>
  </div>
</template>

<script>
import MainPageHeader from '../components/MainPageHeader.vue'
import PageNotFound from '../components/PageNotFound.vue'
import TabFooter from '../components/TabFooter.vue'
import BigButton from '../components/input/BigButton.vue'
import InfoSectionFirstProduct from '../components/infosection/InfoSectionFirstProduct'
import { productDatabase } from '@/services/mock/productDatabase'

export default {
  name: 'FirstProduct',
  components: {
    MainPageHeader,
    PageNotFound,
    TabFooter,
    BigButton,
    InfoSectionFirstProduct,
  },

  data () {
    return {
      productDetails: {
        key: productDatabase[1].key,
        name: productDatabase[1].name,
        price: productDatabase[1].price,
        period: productDatabase[1].period,
        quantity: productDatabase[1].quantity
      },
      successor: null,
      loadError: null,
      description: null,
    }
  },

  mounted () {
    window.scrollTo(0, 0)
  },

  methods: {
    route (location) {
      this.$router.push(location)
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.FirstProduct {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;
  grid-template-areas: 'header'
            'content'
            'footer';
  min-height: 100vh;
}

.MainPageHeader {
  grid-area: header;
}

.Footer {
  grid-area: footer;
}

.content {
  grid-area: content;
  padding: 0 20px;
  margin-top: 90px;

  header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 auto 10px;
    max-width: 1300px;

    .back-button {
      display: flex;
      align-items: center;
      padding: 10px;
      color: white;
      background-color: transparent;
      border-radius: 3px;
      text-decoration: none;

      p {
        display: inline-block;
        margin: 0 0 0 0.7em;
      }
    }

    h1 {
      margin-left: 50px;
      color: $primary;
    }
  }

  .text-header {
    padding: 20px 0;
    text-align: center;
    color: white;

    strong {
      color: $primary;
    }
  }

  .section-1 {
    justify-content: center;
    margin-bottom: 40px;
    color: white;
    font-size: 24px;
    text-align: center;
    padding: 0 10px;

    h2 {
      color: $primary;
    }

    .firstPart {
      margin-top: 100px;
      margin-bottom: 75px;
      flex: 1 1;
      display: flex;
      justify-content: space-evenly;

      .info {
        width: fit-content;
        text-align: center;
        font-size: 23px;
        margin: 0;

        p {
          max-width: 700px;
          width: 540px;
          margin: 70px auto;
        }

      }

      .image-placeholder {
        width: 650px;
        height: 100%;
        margin: 0;
      }
    }

    .info {
      width: 80%;
      margin: 0 auto;

      p {
        margin: 0 auto;
      }
    }

    .image {
      flex: 1 1;
      display: flex;
      /* justify-content: flex-end; */

      .image-placeholder {
        max-width: 750px;
        background-color: black;
        margin: 0 auto;
        margin-bottom: 40px;
      }

      .image-placeholder1 {
        width: 500px;
        margin: 20px auto;
      }
    }

    strong {
      color: $primary;
    }

  }

  .section-2 {
    margin: 0 auto;
    max-width: 1200px;
    color: #ccc;
    text-align: center;

    .big-button {
      display: block;
      margin: 30px auto;
    }

    strong {
      color: $primary;
    }
  }

  .divider {
    border-bottom: 1px solid #aaa;
  }
}

@media (max-width: 1280px) and (-webkit-min-device-pixel-ratio: 1.1) {
  .content {
    justify-content: center;
    align-items: center;

    h1 {
      font-size: 1.2em;
      text-align: center;
      margin: 30px 0;
    }

    .section-1 {
      display: grid;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 0;

      .firstPart {
        flex-direction: column;
        align-items: center;
        margin-top: 20px;
        margin-bottom: 20px;

        h2 {
          margin-bottom: -50px;
        }

        .image-placeholder {
          max-width: 500px;
        }

        .info {
          max-width: 100%;

          p {
            width: 100%;
            margin-bottom: 20px;
          }
        }
      }

      .info {
        margin: 20px auto 0;
        width: 100%;
      }

      h2 {
        margin: 0 auto 10px;
      }

      .image {
        margin: 20px 0 0 0;
        display: block;

        .image-placeholder {
          max-width: 500px;
          margin-bottom: 0;
        }

        .image-placeholder1 {
          max-width: 300px;
        }
      }
    }

    .section-2 {
      font-size: 12px;
      margin: 0 auto;

      h1 {
        font-size: 17px;
      }

      h4 {
        font-size: 14px;
      }
    }

    .section-tab {
      margin: 50px 0;
      flex-direction: column;
      align-items: center;

      h1 {
        margin: 0px 0 00px 0;
      }

      .info {
        text-align: center;

        .image-placeholder {
          margin: 20px auto;
          width: 500px;
          max-width: 80vw;
        }

        .WeirdCounter {
          font-size: 1rem;
        }

        .indented {
          margin: 0;
          margin-top: 30px;
        }
      }

      .image {
        margin: 0px 0 0px 0;

        .image-placeholder {
          width: 500px;
        }

      }

      .buttons {
        display: flex;
        flex-direction: column-reverse;

        .mini-button {
          color: white;
          margin: 10px 0;
          padding: 10px 30px;
          border: 1px solid white;
          text-align: center;
        }
      }
    }
  }
}

// Mobile style
@media (max-width: $phone-max-width) {
  .content {
    justify-content: center;
    align-items: center;

    h1 {
      font-size: 1.2em;
      text-align: center;
      margin: 30px 0;
    }

    .section-1 {
      display: grid;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 0;

      .firstPart {
        flex-direction: column;
        align-items: center;
        margin-top: 20px;
        margin-bottom: 20px;

        h2 {
          margin-bottom: -50px;
        }

        .image-placeholder {
          max-width: 200px;
        }

        .info {
          max-width: 100%;

          p {
            width: 100%;
            margin-bottom: 20px;
          }
        }
      }

      .info {
        margin: 20px auto 0;
        width: 100%;
      }

      h2 {
        margin: 0 auto 10px;
      }

      .image {
        margin: 20px 0 0 0;
        display: block;

        .image-placeholder {
          max-width: 270px;
          margin-bottom: 0;
        }

        .image-placeholder1 {
          max-width: 270px;
        }
      }
    }

    .section-2 {
      font-size: 12px;
      margin: 0 auto;

      h1 {
        font-size: 17px;
      }

      h4 {
        font-size: 14px;
      }
    }

    .section-tab {
      margin: 50px 0;
      flex-direction: column;
      align-items: center;

      h1 {
        margin: 0px 0 00px 0;
      }

      .info {
        text-align: center;

        .image-placeholder {
          margin: 20px auto;
          width: 270px;
          max-width: 80vw;
        }

        .WeirdCounter {
          font-size: 1rem;
        }

        .indented {
          margin: 0;
          margin-top: 30px;
        }
      }

      .image {
        margin: 0px 0 0px 0;

        .image-placeholder {
          width: 270px;
        }

      }

      .buttons {
        display: flex;
        flex-direction: column-reverse;

        .mini-button {
          color: white;
          margin: 10px 0;
          padding: 10px 30px;
          border: 1px solid white;
          text-align: center;
        }
      }
    }
  }
}

@media screen and (min-width: 600px) and (max-width: $phone-max-width){
  .image-placeholder {
    max-width: 500px !important;
  }
}


</style>
